import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import AddressInput from '@/components/forms/AddressInput';
import { useAppSelector } from '@/hooks/useAppSelector';
import { selectCurrentPassenger } from '@/data/passenger.slice';

import type { ReservationFormInput } from '../schema/reservationForm.schema';
import { useReservationFormMachines } from '../ReservationFormMachinesContext';
import { useFieldActorSnapshot } from '../hooks/useFieldActorSnapshot';

export function TripArrayFieldAddressInput({
  index,
  tripField,
  label,
  required,
}: {
  tripField: 'pickupAddress' | 'dropoffAddress';
  index: number;
  label: string;
  required?: boolean;
}) {
  const { watch, setValue, setError, clearErrors, formState } =
    useFormContext<ReservationFormInput>();
  const { fieldRefs } = useReservationFormMachines();
  const actor = fieldRefs[tripField];
  useFieldActorSnapshot(actor);

  const name = `trips.${index}.${tripField}` as const;
  const place = useWatch({ name });

  useEffect(() => {
    actor.send({
      type: 'CHANGE',
      index,
      value: place ?? '',
    });
  }, [actor, index, place]);

  const passenger = useAppSelector(selectCurrentPassenger);
  const passengerAddresses = passenger?.passengerAddresses ?? [];

  const structFieldError =
    formState.errors.trips?.[index]?.[tripField]?.message;

  return (
    <AddressInput
      name={name}
      label={label}
      required={required}
      errorMessage={structFieldError ? String(structFieldError) : ''}
      watch={watch}
      setValue={setValue}
      errorHandlers={{ setError, clearErrors }}
      passengerAddresses={passengerAddresses}
    />
  );
}
